import { isFuture, isPast, secondsToMilliseconds } from 'date-fns';

import { RBTechnical } from 'store/railsBuilder/reducer.types';

import { TECHNICAL_DEVICE_TYPE } from 'services/data-manager/constants';

function findCatchupTechnical(technicals: RBTechnical[] | undefined) {
    if (technicals) {
        const technicalsByDeviceType = technicals?.filter(({ deviceType }) =>
            deviceType.includes(TECHNICAL_DEVICE_TYPE),
        );

        // 1. Look for LTCU + valid
        const ltcuTechnical = technicalsByDeviceType?.find(
            (technical) =>
                technical.isLTCU && isCatchupTechnicalValid(technical),
        );

        if (ltcuTechnical) {
            return ltcuTechnical;
        }

        // 2. Look for STCU + valid
        const stcuTechnical = technicalsByDeviceType?.find(
            (technical) =>
                technical.isSTCU && isCatchupTechnicalValid(technical),
        );

        if (stcuTechnical) {
            return stcuTechnical;
        }

        // 3. Look for valid only.
        return technicalsByDeviceType?.find((technical) =>
            isCatchupTechnicalValid(technical),
        );
    }

    return undefined;
}

export default findCatchupTechnical;

function isCatchupTechnicalValid({
    CUStartDate,
    CUEndDate,
    period,
}: RBTechnical) {
    return (
        isPast(secondsToMilliseconds(CUStartDate)) &&
        isFuture(secondsToMilliseconds(CUEndDate)) &&
        typeof period.start === 'number' &&
        typeof period.end === 'number' &&
        isPast(secondsToMilliseconds(period.start)) &&
        isFuture(secondsToMilliseconds(period.end))
    );
}
